import React, { Dispatch, ReactElement, useEffect, useState } from "react";
import airpressureLayer from "../assets/airpressureLayer.png";
import { useMapLayersContext } from "../provider/MapLayers";
import { LocationMarkerPopup } from "../mainLayer/MainWindow";

type LayerAirPressurePropsType = {
  name: string;
  color?: string;
};

const LayerAirPressure = (props: LayerAirPressurePropsType) => {
  const { selectLayerInMap, loadLayerInMap,setIsAirPressureLoad } = useMapLayersContext();
  const [isSelectedAirPressure, setIsSelectedAirPressure] =
    useState<boolean>(false);

  useEffect(() => {
    if (loadLayerInMap === "airPressure") {
      setIsSelectedAirPressure(true);
    } else if (loadLayerInMap !== "airPressure") {
      setIsSelectedAirPressure(false);
    }
  }, [loadLayerInMap]);

  const airPressureIconClick = () => {
    // if (loadLayerInMap !== "airPressure") {
    //   setIsSelectedAirPressure((prevState) => !prevState);
    // }
    if (!isSelectedAirPressure) {
      selectLayerInMap("airPressure");
    } else {
      selectLayerInMap("airPressurenot");
    }
    setIsAirPressureLoad(false);
  };

  // useEffect(() => {
  //   if (isSelectedAirPressure) {
  //     selectLayerInMap("airPressure");
  //   }else{
  //     LocationMarkerPopup("airPressurenot");
  //   }
  // }, [isSelectedAirPressure]);

  return (
    <div
      className={`subItemWrapper`}
      onClick={(e) => airPressureIconClick()}
      onTouchStart={(e) => airPressureIconClick()}
    >
      {props.color && (
        <div
          className={`colorBox ${isSelectedAirPressure ? "selected" : ""}`}
          style={{ backgroundColor: `${props.color}` }}
        ></div>
      )}

      <div className={`colorBox ${isSelectedAirPressure ? "selected" : ""}`}>
        <img src={airpressureLayer} alt="" />
      </div>

      <span>{props.name}</span>
    </div>
  );
};

export default LayerAirPressure;
